import React, { FunctionComponent } from 'react'
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { useSelector } from 'react-redux'
import { ItemAction } from '../../api/types'
import { themeSelector } from '../../redux/theme/selector'
import { iconFont } from '../../services/Icon'
import { IconType } from '../../services/weather'
import { theme as defaultTheme } from '../../theme'

export const BUBBLE_FONT_SIZE = 14

export interface BubbleActionProps {
  link: {
    label?: string
    labelIn?: string
    image?: string
    icon?: string | React.JSX.Element
    iconTheme?: IconType
    action?: ItemAction
  }
  onPress?: () => void
}

const BubbleAction: FunctionComponent<BubbleActionProps> = ({ link, onPress }) => {
  const theme = useSelector(themeSelector)
  const color = theme ? theme.brandPrimary : defaultTheme.bubble.color

  const getIcon = () => {
    if (link.image) {
      return <Image source={{ uri: link.image }} resizeMode="contain" style={styles.iconImage} />
    }
    if (link.icon) {
      if (typeof link.icon !== 'string') {
        return link.icon as React.JSX.Element
      }

      const IconComponent = iconFont(link.iconTheme || '')
      return <IconComponent name={link.icon} size={24} color={color} style={styles.icon} />
    }
    if (link.labelIn) {
      return <Text style={[styles.iconText, { color }]}>{link.labelIn}</Text>
    }
    return null
  }

  return (
    <TouchableOpacity style={styles.touchable} onPress={onPress}>
      <View style={[styles.button, { borderColor: color }]}>{getIcon()}</View>
      {link.label && <Text style={styles.text}>{link.label}</Text>}
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  touchable: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    textAlign: 'center',
    fontSize: BUBBLE_FONT_SIZE,
  },
  button: {
    backgroundColor: defaultTheme.colors.transparent,
    borderWidth: 1,
    width: defaultTheme.bubble.size,
    height: defaultTheme.bubble.size,
    borderRadius: defaultTheme.bubble.size / 2,
    marginVertical: defaultTheme.padding.x1 / 2,
    marginHorizontal: defaultTheme.padding.x1,
    paddingTop: 0,
    paddingBottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 0,
  },
  icon: {
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    textAlign: 'center',
  },
  iconText: {
    fontWeight: 'bold',
    textAlign: 'center',
    paddingLeft: 0,
    paddingRight: 0,
    width: '100%',
  },
  iconImage: {
    width: defaultTheme.bubble.size / 2,
    height: defaultTheme.bubble.size / 2,
  },
})

export { BubbleAction }
